/*
 * The top bar's pages. Primary pages sit in the nav pill; the rest live under "More" so the bar
 * stays one line without a scroller. On narrower screens primaries move into "More" too:
 * `wide` ones below xl, all of them below lg.
 */

export type NavItem = { to: string; label: string; end?: boolean; wide?: boolean };

export const PRIMARY_NAV: readonly NavItem[] = [
  { to: "/", label: "Home", end: true },
  { to: "/inbox", label: "Inbox" },
  { to: "/projects", label: "Projects" },
  { to: "/ideas", label: "Ideas", wide: true },
  { to: "/conversations", label: "Conversations", wide: true },
  { to: "/office", label: "Office", wide: true },
];

export const MORE_NAV: readonly { title: string; items: readonly NavItem[] }[] = [
  { title: "Watch", items: [{ to: "/status", label: "Status" }, { to: "/activity", label: "Activity" }, { to: "/routines", label: "Routines" }] },
  { title: "Set up", items: [{ to: "/team", label: "Team" }, { to: "/skills", label: "Skills" }, { to: "/rules", label: "Rules" }, { to: "/connect", label: "Connect" }] },
];

const matches = (item: NavItem, pathname: string) =>
  item.end ? pathname === item.to : pathname === item.to || pathname.startsWith(`${item.to}/`);

export type NavWidth = "narrow" | "medium" | "wide";

/** The primary pages that don't fit in the pill at this width and go into "More". */
export function movedPrimaries(width: NavWidth): NavItem[] {
  if (width === "narrow") return [...PRIMARY_NAV];
  return width === "medium" ? PRIMARY_NAV.filter((i) => i.wide) : [];
}

/** The "More" item the current page belongs to, so the closed menu can name it. */
export function activeMoreItem(pathname: string, moved: readonly NavItem[]): NavItem | null {
  const pool = [...moved, ...MORE_NAV.flatMap((g) => g.items)];
  return pool.find((i) => matches(i, pathname)) ?? null;
}
